module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAAIhJREFUKBXFUkEOwCAIm/v/V90XHO2sAefwuF4KtCgkHIehtVbBGcxDwHMujZAhFAVIgjUkBbK3Iu+4yBJnDs+o5cXWVdU5RBUheMDwOVAxjD+R0N0Z8RCRzEjF9E+K83OY2tc0j6/xS/Nxf63pDYhV7xwPQKKadnm6pB5Z8b+NvLPNbs8t2uw3ZwmaCmW5hYQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ic_delete_white.png
// module id = 151
// module chunks = 170